.infobox > div {
  width: 100%;
}

.spinner {
  float: right;
}
